import { routes } from '~/components/app/appMainRoutes';
import { settingsRoutes } from '~/components/settings/settingsRoutes';

import { useHomeIntegrations } from '../hooks/useHomeIntegrations';
import { OnboardingChecklist } from './OnboardingChecklist';
import { OnboardingItem, OnboardingItemDivider } from './OnboardingItem';

export const ListTargetMarkets = () => {
  const {
    hasTargetMarketAddedCompanies,
    hasTargetMarketDefinedIcp,
    isHubSpotConnected,
  } = useHomeIntegrations();

  return (
    <OnboardingChecklist title="Get started with Target Markets">
      <OnboardingItem
        isComplete={hasTargetMarketDefinedIcp}
        number={1}
        title="Define your ICP"
        to={routes.targetMarkets}
      />
      <OnboardingItemDivider />
      <OnboardingItem
        isComplete={isHubSpotConnected}
        number={2}
        title="Connect to HubSpot"
        to={settingsRoutes.hubSpotIntegration}
      />
      <OnboardingItemDivider />
      <OnboardingItem
        isComplete={hasTargetMarketAddedCompanies}
        isDisabled={!hasTargetMarketDefinedIcp}
        number={3}
        title="Add companies in your market to your CRM"
        to={routes.targetMarkets}
      />
    </OnboardingChecklist>
  );
};
